import React from 'react'
import HiddenButtons from '@/components/hiddenButtons'
import Icon from '@/components/Icon'
import Name from '@/components/Name'
import { Button } from '@/components/button'

export default class RowItem extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.handleOnDeleteClicked = this.handleOnDeleteClicked.bind(this)
  }

  handleOnDeleteClicked () {
    this.props.actions.delete(this.props.id)
  }

  render () {
    const { id, item, canDelete, canAdd, unitType } = this.props

    return (
      <div>
        <span><strong><Name data={this.props} /></strong> - <Name data={unitType} /></span>
        <HiddenButtons id={id}>
          <Button onClick={() => this.props.actions.detail(id)}><Icon name='pencil' /></Button>
          {canAdd && <Button onClick={() => this.props.actions.add(id, item)}><Icon name='plus' /></Button>}
          {canDelete &&
          <Button confirmTitle='Common.DeleteDialogTitle' confirmText='Common.DeleteDialogText' onClick={this.handleOnDeleteClicked}>
            <Icon name='x' />
          </Button>}
        </HiddenButtons>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/organizationalUnits/treeView/OrganizationalUnitTreeView.RowItem.js